<template>
    <div id="student-manage" class="vx-card p-4">
        <div class="vx-row">
            <div class="vx-col lg:w-3/12 sm:w-6/12 w-full">
                <label class="vs-input--label">{{ $t('navMenu.school') }}</label>
                <v-select class="w-full" v-model="selectedOrganizationBranch" :clearable="false"
                          :options="organizationBranchOptions">
                    <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                </v-select>
            </div>
            <div class="vx-col lg:w-3/12 sm:w-6/12 w-full">
                <label class="vs-input--label">{{ $t('menuPackage.status') }}</label>
                <v-select class="w-full" v-model="selectStatus" :options="statusOption" :clearable="false">
                    <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                </v-select>
            </div>
            <div class="vx-col lg:w-3/12 sm:w-6/12 w-full">
                <label class="vs-input--label">{{ $t('dashboard.className') }}</label>
                <vs-input class="w-full" v-model="className" placeholder="Tìm kiếm theo tên lớp ..."></vs-input>
            </div>
            <div class="vx-col lg:w-3/12 sm:w-6/12 w-full">
                <vs-button icon="icon-search" icon-pack="feather" color="primary" @click="search" class="mt-6">
                    {{ $t('button.search') }}
                </vs-button>
            </div>
            <div class="vx-col w-full mt-6 flex gap-2">
                <vs-button icon="icon-plus" icon-pack="feather" color="primary" @click="addClass"
                           v-show="isPermissionAdd()">
                           {{ $t('button.add') }}
                </vs-button>
                <vs-button icon-pack="feather" icon="icon-download" color="primary" type="border" @click="downloadTemplate">{{ $t('attendance.downloadTemplate') }}</vs-button>
                <vs-button icon-pack="feather" icon="icon-upload-cloud" color="primary" type="border" @click="$refs.fileUpload.click()">{{ $t('attendance.import') }}</vs-button>
                <input ref="fileUpload" type="file" id="fileUpload" accept=".xlsx, .xls, .csv, .xlsm, .xlsb"
                       class="hidden" @change="uploadFile($event)">
            </div>
        </div>

        <!-- AgGrid Table -->
        <ag-grid-vue style="height: 55vh"
                     ref="agGridTable"
                     :gridOptions="gridOptions"
                     class="ag-theme-material w-100 my-4 ag-grid-table"
                     :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="classData"
                     :animateRows="true"
                     :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                     :onGridReady="onGridReady"
                     :autoSizeStrategy="autoSizeStrategy">
        </ag-grid-vue>

        <div class="vx-row" v-if="totalElements > 0">
            <div class="w-full flex">
                <div style="min-width:200px">
                    <span class="content-page font-bold ml-4">Hiển thị: </span><span class="text-page">{{
                        countElementPage > totalElements ? totalElements : countElementPage
                    }} /
                            {{ totalElements }} </span>
                </div>
                <vs-pagination :total="totalPages" v-model="currentPage"
                               @change="loadDataByPage"/>
            </div>
        </div>

        <vs-popup class="holamundo popupError" title="Lỗi tải lên tệp nhân viên" :active.sync="popupErrorImport">
            <div class="">
                <div>
                    <vs-table stripe :data="errorData" pagination max-items="10">
                        <template slot="thead">
                            <vs-th>{{ $t('dashboard.numericalOrder') }}</vs-th>
                            <vs-th> {{ $t('dashboard.dataFields') }}</vs-th>
                            <vs-th> {{ $t('dashboard.row') }}</vs-th>
                            <vs-th> {{ $t('dashboard.colum') }}</vs-th>
                            <vs-th> {{ $t('dashboard.error') }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(item, indextr) in data">
                                <vs-td> {{ item.stt }}</vs-td>

                                <vs-td> {{ item.header }}</vs-td>

                                <vs-td> {{ item.rowNumError }}</vs-td>

                                <vs-td> {{ item.colChar }}</vs-td>

                                <vs-td> {{ item.message }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../ui-elements/Pagination.vue"
import CellRendererStatus from './cell-renderer/CellRendererStatus'
import CellRendererActions from './cell-renderer/CellRendererActions'
import {isAPI, isRouter} from "../../../store/permission"
import {constAPI, constRouter} from "../../../store/constant"
import authConfig from '@/../auth_config.json'
import moment from "moment";

export default {
    data() {
        return {
            checkEmployee: true,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                flex: 1,
            },
            columnDefs: [
                {
                    headerName: this.$t('dashboard.classCode'),
                    field: 'id',
                    width: 100
                },
                {
                    headerName: this.$t('dashboard.className'),
                    field: 'className',
                    width: 200
                },
                {
                    headerName: this.$t('wifi.branch'),
                    field: 'organizationBranchName',
                    width: 200,
                },
                {
                    headerName: this.$t('menuOrganization.status'),
                    field: 'status',
                    cellRenderer: 'CellRendererStatus',
                    width: 200,
                },
                {
                    headerName: this.$t('invoice.note'),
                    field: 'description',
                    width: 200,
                },
                {
                    headerName: this.$t('menuOrganization.createdDate'),
                    field: 'createdDateStr',
                    width: 200,
                },
                {
                    headerName: this.$t('menuOrganization.modifiedDate'),
                    field: 'modifiedDateStr',
                    width: 200,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRenderer: 'CellRendererActions',
                },
            ],
            className: null,
            statusOption: [
                {value: null, label: 'Tất cả'},
                {value: 0, label: 'Đang hoạt động'},
                {value: 1, label: 'Ngừng hoạt động'},
            ],
            classData: [],
            statusValue: null,
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            countElementPage: 0,
            totalElements: 0,
            totalPages: 0,
            currentPage: 1,
            pageNumber: 0,
            pageSize: 20,
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            popupErrorImport: false,
            errorData: [],
        }
    },

    components: {
        AgGridVue,
        Pagination,
        vSelect,
        CellRendererStatus,
        CellRendererActions
    },

    created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: this.$t('warningMenuOrganization.emptyEmployee'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }
        this.organizationBranchOptions = branchList.filter(x => x.organizationBranchType === 3).map(item => {
            return {value: item.id, label: item.organizationBranchName}
        });
        this.organizationBranchOptions.unshift({value: null, label: this.$t('menuOrganization.all')})

        this.search()
    },

    watch: {
        '$store.state.isDeleteClass'(val) {
            if (val) {
                this.search();
                this.$store.commit('DELETE_CLASS', false);
            }
        }
    },

    computed: {
        selectedOrganizationBranch: {
            get() {
                let obj = this.organizationBranchOptions.find(x => x.value == this.selectedOrganizationBranchValue)
                if (!obj) return
                return {
                    label: obj.label,
                    value: obj.value
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null
            }
        },
        selectStatus: {
            get() {
                let obj = this.statusOption.find(x => x.value == this.statusValue)
                if (!obj) return
                return {
                    label: obj.label,
                    value: obj.value
                }
            },
            set(obj) {
                this.statusValue = obj ? obj.value : null
            }
        }
    },

    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.class_add)
        },
        loadDataByPage(event) {
            if (this.pageNumber != parseInt(event) - 1) {
                this.pageNumber = parseInt(event) ? parseInt(event) - 1 : 0;
                this.currentPage = event
                if (this.pageNumber > 0) this.studentName = null
                this.search();
            }
        },

        addClass() {
            this.$router.push('/user/class-info').catch(() => {
            })
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        search() {
            let schoolClassSearchDTO = {
                className: this.className,
                organizationBranchId: this.selectedOrganizationBranchValue,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                sort: 'id',
                status: this.statusValue == 0 ? true : this.statusValue == 1 ? false : null
            }

            this.$vs.loading()
            this.$crm.post('/school-classroom/search', schoolClassSearchDTO).then(res => {
                this.classData = res.data.content.map(el => {
                    let branch = this.organizationBranchOptions.find(x => x.value == el.organizationBranchId)
                    el.organizationBranchName = branch ? branch.label : '';
                    el.createdDateStr = el.createdDate ? moment(el.createdDate).format('DD/MM/YYYY') : null;
                    el.modifiedDateStr = el.modifiedDate ? moment(el.modifiedDate).format('DD/MM/YYYY') : null;
                    return el
                })
                this.countElementPage = this.currentPage * this.pageSize;
                this.totalElements = res.data.totalElements;
                this.totalPages = res.data.totalPages
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        downloadTemplate() {
            this.$vs.loading()
            this.$crm.get('/school-classroom/download-template').then(res => {
                this.$vs.loading.close();
                window.open(authConfig.crmDomain + "file/beauty/" + res.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        isExcel(file) {
            return /\.(xlsx|xls|csv|xlsm|xlsb)$/.test(file.name)
        },
        uploadFile(e) {
            let file = [...e.target.files];
            if (!this.isExcel(file[0])) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Chỉ hỗ trợ tệp có định dạng .xlsx, .xls, .csv, .xlsm, .xlsb',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }

            let formData = new FormData();
            formData.append('file', file[0]);
            this.errorData = [];
            this.$vs.loading();
            this.$crm.post(`/school-classroom/import-excel`, formData).then(res => {
                this.$vs.loading.close();
                if (res.data && res.data.length > 0) {
                    this.popupErrorImport = true;
                    this.errorData = res.data.map(el => {
                        el.stt = res.data.indexOf(el) + 1;
                        return el;
                    });
                } else {
                    this.$vs.notify({
                        text: 'Nhập dữ liệu thành công!',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    });
                    if (this.pageNumber === 0) {
                        this.search();
                    } else {
                        this.loadDataByPage(1);
                    }
                }
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
            this.$refs.fileUpload.value = null;
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>
